import React from 'react'
import moment from 'moment'

import TableCheckbox from '@/modules/drivers/shared/tableItems/TableCheckbox'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { getAttestationType } from '@/app/services/attestation/attestationTypeResolver'
import { getAttestationName } from '@/app/services/attestation/attestationNameResolver'

export type AttestationRow = {
  id: number
  attestationType: number
  startTime: string | null
  endTime: string | null
  activityStartTime: string | null
  activityEndTime: string | null
  createdDate: string | null
  acceptedDate: string | null
  issuer: string | null
  position: string | null
}

type Props = {

  selectedIds: (string | number)[]
  attestation: AttestationRow
  toggleId: (id: string | number, checked: boolean) => void
}

const formatDateTime = (value: string | null | undefined): string =>
  value ? moment(value).format('YYYY-MM-DD HH:mm') : '-'

const formatDate = (value: string | null | undefined): string =>
  value ? moment(value).format('YYYY-MM-DD') : '-'

const AttestationRowItem: React.FC<Props> = ({
  selectedIds,
  attestation,
  toggleId,
}) => {
  const { t } = useLocalize()

  const isChecked = selectedIds.includes(Number(attestation?.id))
  const [isHovered, setIsHovered] = React.useState(false)

  const typeLabel = attestation?.attestationType
    ? getAttestationName(getAttestationType(attestation.attestationType), t)
    : '-'

  return (
    <tr
      className={`notches-border--right tw-relative tw-cursor-pointer tw-border-b hover:tw-bg-primary/10 ${
        isChecked ? 'selected tw-bg-primary/10' : 'tw-bg-white'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => toggleId(Number(attestation?.id), !isChecked)}
    >
      <TableCheckbox
        isHovered={isHovered}
        background
        disabled={false}
        checked={isChecked}
        onChange={(checked) => toggleId(Number(attestation?.id), checked)}
      />
      <TableTextRow size="small">{typeLabel}</TableTextRow>
      <TableTextRow size="small">{formatDateTime(attestation?.startTime)}</TableTextRow>
      <TableTextRow size="small">{formatDateTime(attestation?.endTime)}</TableTextRow>
      <TableTextRow size="small">{formatDateTime(attestation?.activityStartTime)}</TableTextRow>
      <TableTextRow size="small">{formatDateTime(attestation?.activityEndTime)}</TableTextRow>
      <TableTextRow size="small">{formatDate(attestation?.createdDate)}</TableTextRow>
      <TableTextRow size="small">{formatDate(attestation?.acceptedDate)}</TableTextRow>
      <TableTextRow size="small">{attestation?.issuer || '-'}</TableTextRow>
      <TableTextRow size="small">{attestation?.position || '-'}</TableTextRow>
    </tr>
  )
}

export default AttestationRowItem
